import { usePage } from "@inertiajs/react"

import { Alert, AlertDescription } from "@/components/ui/alert"
import { Head } from '@inertiajs/react'
import { AppSidebar } from "@/components/app_sidebar"
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb"
import { Separator } from "@/components/ui/separator"
import {
  SidebarInset,
  SidebarProvider,
} from "@/components/ui/sidebar"
import { X } from "lucide-react"

import * as api from "@/api"
import { useForm } from "@inertiajs/react"

export default function Layout({ children, breadcrumbs = [] }) {
  const { social_media, auth } = usePage().props

  const allSocialsConnected = social_media?.twitter && social_media?.linkedin
  const showSocialMediaBanner = !allSocialsConnected && auth.organization?.subscribed && !auth.first_use?.social_media_banner_dismissed_at

  const { patch, transform } = useForm({
    social_media_banner_dismissed_at: null
  })

  const handleSubmit = () => {
    transform(_ => ({
      first_use: {
        social_media_banner_dismissed_at: new Date()
      }
    }))

    patch(api.organizationsFirstUse.update.path({ org_nano_id: auth.organization.nano_id }))
  }

  return (
    <>
      <Head>
        <title>founder/mode</title>
      </Head>

      <SidebarProvider>
        <AppSidebar />
        <SidebarInset>

          <Alert className={`rounded-none border-x-0 border-t-0 bg-primary/70 text-primary-foreground ${showSocialMediaBanner ? 'block' : 'h-[1px] opacity-0 pointer-events-none flex-shrink p-0 overflow-hidden'}`}>
            <div className="flex flex-col md:flex-row gap-3 items-start md:items-center justify-between">
              <AlertDescription className="font-bold">
                Connect your Twitter and LinkedIn accounts to get started with all features.
              </AlertDescription>

              <div className="flex items-center gap-2">
                <turbo-frame id="omniauth" src={`/auth/omniauth?org_nano_id=${auth.organization.nano_id}`}></turbo-frame>

                { social_media?.twitter || social_media?.linkedin ? (
                  <button className="" onClick={handleSubmit}>
                    <X className="size-5" />
                  </button>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </Alert>

          <header className="flex h-4 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12">
            <div className="flex items-center gap-2 px-4">
              {breadcrumbs.length > 0 && (
                <>
                  <Separator orientation="vertical" className="mr-2 h-4" />
                  <Breadcrumb>
                    <BreadcrumbList>
                      {breadcrumbs.map((breadcrumb, index) => (
                        <>
                          <BreadcrumbItem className="hidden md:block">
                            <BreadcrumbLink href={breadcrumb.url}>
                              {breadcrumb.label}
                            </BreadcrumbLink>
                          </BreadcrumbItem>

                          {index < breadcrumbs.length - 1 && (
                            <BreadcrumbSeparator className="hidden md:block" />
                          )}
                        </>
                      ))}
                    </BreadcrumbList>
                  </Breadcrumb>
                </>
              )}
            </div>
          </header>

          <div className="flex flex-1 flex-col gap-4 p-10 pt-0">
            {children}
          </div>
        </SidebarInset>
      </SidebarProvider>
    </>
  )
}
